<template>
  <div id="index">
    <div class="check_box">
      <div style="width: 100%; height: 1px"></div>
      <img class="titleimg" src="../../assets/imgs/image/tp_03.png" alt />
      <div class="regionCheckBox">
        <el-row class="row_margin_top" style="line-height: 40px">
          <el-col class="fontS" :xs="8" :lg="5">请选择地区：</el-col>
          <el-col :span="12" class="input_style_box">
            <el-cascader
              :popper-append-to-body="false"
              popper-class="input_style"
              class="input_style"
              :props="{ checkStrictly: true }"
              v-model="value"
              :options="options"
              size="mini"
            ></el-cascader>
          </el-col>
        </el-row>
        <el-row class="row_margin">
          <el-col align="center">
            <el-button type="primary" @click="checkP" class="btn_style" style=""
              >确定</el-button
            >
            <el-button type="info" @click="value = []" class="btn_style"
              >重置</el-button
            >
          </el-col>
        </el-row>
        <div
          style="
            color: #cccccc;
            text-align: center;
            width: 100%;
            margin: 0 auto;
            line-height: 20px;
            font-size: 12px;
          "
        >
          *请注意选中地区后，系统会初始化该地区的地图以及区县数据，系统创建成功后不可修改。
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" center>
      <span
        >确定要选择
        <span style="color: #f00">{{ checkVal }}</span>
        地区生成相应的地图数据吗？</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible1" width="30%" center>
      <span style="display: block; text-align: center">请先选择地区</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      dialogVisible1: false,
      formInline: {
        user: "",
        region: "",
      },
      value: [],
      options: [],
      checkVal: "",
    };
  },
  methods: {
    checkP() {
      let _this = this;
      if (_this.value.length > 0) {
        _this.checkVal = _this.value[_this.value.length - 1];
        _this.$axios
          .get(`/business/mapSite/getTree?code=${_this.checkVal}`)
          .then((res) => {
            this.checkVal = res.data.data.label;
          });
        _this.dialogVisible = true;
      } else {
        _this.dialogVisible1 = true;
      }
    },
    onSubmit() {
      console.log("submit!");
      let _this = this;
      _this.$axios
        .get(
          `/business/mapSite/setUpSystemMap?code=${
            _this.value[_this.value.length - 1]
          }`
        )
        .then((res) => {
          this.$router.push("/home");
        });
    },
    getList() {
      let _this = this;
      _this.$axios.get("/business/mapSite/getTree").then((res) => {
        _this.options = res.data.data.children;
      });
    },
  },
  computed: {},
  created() {
    this.getList();
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
#index {
  height: 100%;
  background: url(../../assets/imgs/background/home_bg.gif) center no-repeat;
  background-color: #122544;
  position: relative;
}

.check_box {
  width: 60%;
  height: 90%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}

.regionCheckBox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 560px;
  height: 400px;
  // background-color: #122544;
  background: url(../../assets/imgs/background/check.png) center no-repeat;
  background-size: contain;
  border-radius: 10px;
  padding: 70px 30px 40px;
}
.fontS {
  color: #fff;
  font-size: 14px;
  margin-left: 18%;
}
.row_margin {
  margin: 80px 0;
}

img.titleimg {
  // width: 96%;
  height: 180px;
  margin: 0px auto 20px;
}

.btn_style {
  width: 120px;
  height: 40px;
  background: #00456d;
  border: 1px solid #00e8ff;
  border-radius: 3px;
}

.btn_style:hover {
  width: 120px;
  height: 40px;
  background: #0be9ff;
  border: 0px solid #00e8ff;
  border-radius: 3px;
  color: #000;
}
@media (max-width: 1200px) {
  .check_box {
    width: 90%;
    height: 90%;
  }
  .regionCheckBox {
    width: 100%;
  }
  img.titleimg {
    width: 100%;
    height: auto;
    margin-top: 40px;
  }
  .fontS {
    color: #fff;
    font-size: 14px;
    margin-left: 5.4%;
  }
  .row_margin_top {
    margin-top: 20%;
  }
  .row_margin {
    margin: 20px 0 30px;
  }
  .regionCheckBox {
    background-size: 100% 64%;
  }
}
</style>
<style>
.input_style_box .el-input--mini .el-input__inner {
  background: #262626;
  border: 2px solid #0be9ff;
}

.input_style_box .el-input__inner {
  color: #fff;
}

.input_style_box .el-cascader:not(.is-disabled):hover .el-input__inner {
  border-color: #0be9ff !important;
}

.input_style .el-cascader-node:not(.is-disabled) {
  background: rgba(0, 0, 0, 0) !important;
  color: #fff !important;
}

.input_style .el-cascader-node.is-selectable.in-active-path {
  color: #0be9ff !important;
}

.input_style .el-cascader-node:not(.is-disabled):hover {
  background: rgba(0, 0, 0, 0) !important;
}

.input_style .el-cascader-panel {
  background: #262626 !important;
  border: 2px solid #0be9ff;
  border-radius: 3px;
}

.input_style .el-radio__input.is-checked .el-radio__inner {
  border-color: #0be9ff !important;
  background: #0be9ff !important;
}

.input_style .el-radio__inner {
  border: 1px solid #dde0e6 !important;
  background: #262626 !important;
}

.input_style .popper__arrow::after {
  border-bottom-color: #0be9ff !important;
}
.input_style {
  border: 0 !important;
}

.input_style .el-cascader-menu {
  border-right-color: #0be9ff !important;
}
</style>